export const getDDragonVersion = async () => {
    try {
        const versionData = await fetch(`https://ddragon.leagueoflegends.com/api/versions.json`)
        const version = await versionData.json();
        return version[0]
    } catch (err) {
        console.log(err)
        return 'Error al obtener la version de DDragon. Intentá mas tarde.'
    }
    }